/**
 * Javascript file for the selected potential project partners page.
 * @author Yannik Sprengart, Andrea Villeda
 */

import { getTechpartners, getCompanyProfile } from "../../../../api";
export default {
    name: "MyPartners",

    /**
     * The vue instance's data object.
     * @property {object} profile - The company's profile.
     * @property {any[]} partners - The result set for the selected partners.
     * @property {boolean} loading - Information is currently being loaded.
     */
    data() {
        return {
            profile: null,
            partners: [],
            loading: false,
        };
    },

    /**
     * The vue instance's method declaration.
     */
    methods: {
        /**
         * Returns to the previously visited page.
         */
        goBack() {
            this.$router.go(-1);
        },

        /**
         * Shortens the description.
         * @param {*} desc - The description. 
         */
        shorten(desc) {
            if (desc) {
                var res = desc.substring(0, 500) + "...";
                return res;
            }
            return "";
        },
    },

    /**
     * Called after the instance has been created.
     */
    created() {
        this.loading = true;
        this.has_error = false;
        this.error_message = "Keine geeigneten Partner gefunden.";
        getCompanyProfile()
            .then((pro) => {
                //console.log(pro);

                //If there is no profile for this company in the database.
                if (!pro) {
                    console.log("Du hast kein Profil. Bist Du ein KI-Trainer?");
                    this.loading = false;
                    this.has_error = true;
                    return;
                }

                //If there is a profile for this company.
                this.profile = pro;
                let promises = [];
                if (this.profile.requested.length > 0) {
                    for (let i = 0; i < this.profile.requested.length; i++) {
                        let p = getTechpartners(this.profile.requested[i].hash)
                            .then((res) => {
                                if (res.length == 0) {
                                } else {
                                    for (let j = 0; j < res.length; j++) {
                                        // console.log(res[j]);
                                        this.partners.push(res[j]);
                                    }
                                }
                            })
                            .catch((err) => {
                                //console.log(err);
                                this.has_error = true;
                                this.loading = false;
                            });
                        promises.push(p);
                    }
                    Promise.all(promises)
                        .then(() => {
                            this.partners.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            this.loading = false;
                        })
                        .catch((err) => {
                            console.log(err);
                            this.has_error = true;
                            this.loading = false;
                        });
                } else {
                    //console.log("mmhh");
                    this.loading = false;
                }
            })
            .catch((err) => {
                console.log(err);
                this.has_error = true;
                this.loading = false;
            });
    },
};


// WEBPACK FOOTER //
// ./src/components/company/profile/partners/mypartners.js